<template>
  <div>
    <b-badge
      v-if="resultsVisibility !== resultsVisibilityOptions.NONE"
      data-test="visibility-badge"
      class="small mr-1 blue-dark blue-light-bg"
    >
      {{ $t('survey.public_results') }}
    </b-badge>
    <b-badge v-if="isAnonymous"
             data-test="anonymous-badge"
             variant="primary-light"
             class="small"
    >
      {{ $t('survey.names_anonymous') }}
    </b-badge>
  </div>
</template>

<script>
import constants from 'src/config/constants.ts'

export default {
  name: 'SduiSurveyBadges',
  props: {
    resultsVisibility: {
      type: String,
      default: constants.survey.resultsVisibility.NONE,
      validator: (value) => Object.keys(constants.survey.resultsVisibility).includes(value.toUpperCase()),
    },

    isAnonymous: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    resultsVisibilityOptions: constants.survey.resultsVisibility,
  }),
}
</script>
